var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFaqCalling(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 166 152",
    style: {
      enableBackground: "new 0 0 166 152"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;stroke:#FFCB03;stroke-width:3;stroke-miterlimit:10;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "TELEPHONE_ICONE"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M127.9,117.98c0,0-1.63,1.69-4.1,3.79c-0.7,0.59-1.46,1.21-2.25,1.83c-4.92,3.85-11.61,7.98-16.13,6.24 C76.37,118.57,46.6,84.19,40.08,45.71c-1.32-7.96,5.79-14.87,11.47-19c0.84-0.64,1.68-1.21,2.44-1.69 c2.33-1.54,4.02-2.39,4.02-2.39l11.24,29.01c0,0-1.41,2.25-2.84,4.98c-0.51,0.98-1.04,2.05-1.49,3.09 c-0.9,1.94-1.57,3.8-1.57,4.98c0,8.88,15.96,33.31,24.26,36.12c1.41,0.48,4.5,0.2,7.7-0.31h0.03c1.09-0.17,2.22-0.37,3.29-0.56 c3.68-0.7,6.78-1.49,6.78-1.49L127.9,117.98z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M65.78,36.36c3.13,8.03,4.7,14.91,3.52,15.37s-4.68-5.67-7.81-13.7s-4.7-14.91-3.52-15.37 C59.15,22.2,62.65,28.33,65.78,36.36z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M115.17,109.89c-6.24-5.39-10.66-10.51-9.86-11.42c0.79-0.92,6.5,2.7,12.74,8.08 c6.24,5.39,10.65,10.51,9.86,11.43C127.12,118.89,121.41,115.27,115.17,109.89z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFaqCalling);
export default __webpack_public_path__ + "static/media/faq-calling.c1b125ebec07aea3346491dc823ecc89.svg";
export { ForwardRef as ReactComponent };